module.exports = __webpack_public_path__ + "static/media/fourty_percent.b40674a4.png";